const columns = [
    {
        title: 'Name',
        dataIndex: 'name',
        // sorter: (a, b) => a?.name?.localeCompare(b?.name),
    },
    {
        title: 'Email',
        dataIndex: 'email',
        // sorter: (a, b) => a?.email?.localeCompare(b?.email),
    },
    {
        title: 'Mobile No',
        dataIndex: 'phoneNo',
        // sorter: (a, b) => a?.phoneNo?.localeCompare(b?.phoneNo),
    },
    {
        title: 'Affiliate Code',
        dataIndex: 'affiliateCode',
        // sorter: (a, b) => a?.affiliateCode?.localeCompare(b?.affiliateCode),
    },
    {
        title: 'A/C No.',
        dataIndex: 'login',
        // sorter: (a, b) => a?.login?.localeCompare(b?.login),
    },
    {
        title: 'A/C Type',
        dataIndex: 'planName',
        // sorter: (a, b) => a?.groupName?.localeCompare(b?.groupName),
    },
    {
        title: 'User Type',
        dataIndex: 'ibUser',
        // sorter: (a, b) => a?.iBUser?.localeCompare(b?.iBUser),
    },
    {
        title: 'Level',
        dataIndex: 'level',
        // sorter: (a, b) => a?.level?.localeCompare(b?.level),
    },
    {
        title: 'Lot',
        dataIndex: 'lot',
        // sorter: (a, b) => a?.lot - b?.lot,
    },
    {
        title: 'Symbol',
        dataIndex: 'symbol',
        // sorter: (a, b) => a?.symbol?.localeCompare(b?.symbol),
    },
    {
        title: 'Deal ID',
        dataIndex: 'dealId',
        // sorter: (a, b) => a?.symbol?.localeCompare(b?.symbol),
    },
    {
        title: 'Amount',
        dataIndex: 'ibCommission',
        // sorter: (a, b) => a?.iBCommission - b?.iBCommission,
    },
    {
        title: 'Commission Type',
        dataIndex: 'commissionType',
    },
    {
        title: 'Date',
        dataIndex: 'ibCommDate',
    },
];

export default columns;